/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $UnattendedRooms = {
    properties: {
        roomId: {
    type: 'number',
},
        roomName: {
    type: 'string',
},
        bedId: {
    type: 'number',
    isRequired: true,
},
        bedName: {
    type: 'string',
    isRequired: true,
},
        employeeId: {
    type: 'number',
},
        employeeName: {
    type: 'string',
},
    },
};